import { apiUrl } from "../config/app";
import ApiService from "./ApiService";

export type ChatHistoryItem = {
  role: "user" | "assistant";
  content: string;
};

const extractAnswer = (payload: any): string | undefined => {
  if (!payload) return undefined;
  return typeof payload.answer === "string" ? payload.answer : undefined;
};

export const sendChatMessage = async (
  message: string,
  history: ChatHistoryItem[] = [],
): Promise<string> => {
  const apiService = new ApiService();
  const payload = { message, history };

  try {
    const response = await apiService.post(`${apiUrl}/chat`, payload);
    const answer = extractAnswer(response);

    if (answer) {
      return answer.trim();
    }

    throw new Error("The chat backend returned an empty response.");
  } catch (error: any) {
    const finalError =
      error instanceof Error ? error : new Error(String(error));
    throw finalError;
  }
};
